import request from '@/utils/request-common'

/**
 * 获取邮箱验证码
 * @param {object} params
 * @param {string} params.email - 邮箱
 * @returns {AxiosPromise}
 */
export function getEmailVerifyCode(params) {
  return request({
    url: '/devOrg/audit/verifyCode',
    method: 'get',
    params
  })
}

/**
 * 获取用户审核信息
 * @param {object} params - 获取审核数据参数
 * @param {string} params.currentUser - 当前登录用户
 * @param {string} params.name - 技术服务提供商名称
 * @param {number} params.page - 分页参数，当前页， 默认值 1
 * @param {number} params.size - 每页数据数量，默认值 20
 * @param {array} params.sort - 排序字段，格式：排序字段,desc
 * @param {array} params.status - 状态
 * @returns {AxiosPromise}
 */
export function getUserAuditPage(params) {
  return request({
    url: '/devOrg/audit/userPage',
    method: 'get',
    params
  })
}

/**
 *  审核拒绝
 * @param {object} data - 拒绝审核的数据
 * @param {number} data.id - 审核记录ID
 * @param {string} data.rejectReason - 拒绝理由
 * @returns {AxiosPromise}
 */
export function auditReject(data) {
  return request({
    url: '/devOrg/audit/reject',
    method: 'post',
    data
  })
}

/**
 * 重新提交审核
 * @param {object} data
 * @param {string} data.address - 地址
 * @param {string} data.decription - 描述
 * @param {string} data.email - 邮箱
 * @param {number} data.id - 技术服务商id
 * @param {string} data.organizationName - 技术服务提供商的名称
 * @param {string} data.phone - 电话
 * @returns {AxiosPromise}
 */
export function auditRecommit(data) {
  return request({
    url: '/devOrg/audit/recommit',
    method: 'post',
    data
  })
}

/**
 * 审核通过
 * @param data
 * @param {number} data.id - 技术服务商 id
 * @returns {AxiosPromise}
 */
export function auditPass(data) {
  return request({
    url: '/devOrg/audit/pass',
    method: 'post',
    data
  })
}

/**
 * 获取通知消息
 * @returns {AxiosPromise}
 */
export function auditNotices() {
  return request({
    url: '/devOrg/audit/notices',
    method: 'get'
  })
}

/**
 * 取消审核
 * @param data
 * @param {number} data.id - 技术服务商 id
 * @returns {AxiosPromise}
 */
export function auditCancel(data) {
  return request({
    url: '/devOrg/audit/cancel',
    method: 'post',
    data
  })
}

/**
 * 获取所有的审核消息
 * @param params
 * @param {string} params.currentUser - 当前登录用户
 * @param {string} params.name - 技术服务提供商名称
 * @param {number} params.page - 页，默认值 1
 * @param {number} params.size - 每页数据量，默认值 20
 * @param {array} params.sort - 排序，格式: 排序字段,desc
 * @param {array} params.status - 状态
 * @returns {AxiosPromise}
 */
export function getAuditAllPage(params) {
  return request({
    url: '/devOrg/audit/allPage',
    method: 'get',
    params
  })
}
